import React, { useCallback, useLayoutEffect } from 'react';
import { useBreakpointHelpers } from '@sweetgreen/garnish';

import { LoadingAnimation } from '@order/components';
import { useDeliveryOrderInFlight } from '@order/hooks';

import type { HomeScreenProps } from '../../navigation/AppNavigation.props';
import { useShakeToSummonScanToPay } from '../ScanToPayScreen/hooks';
import { HomeScreenContent } from './components';
import {
  useHomeData,
  useHomeHeroCTA,
  useHomeScreenLoadedContent,
} from './hooks';

export const HomeScreen = ({ navigation }: HomeScreenProps) => {
  const { isMobile } = useBreakpointHelpers();

  const loadedContent = useHomeScreenLoadedContent();

  const data = useHomeData();

  useDeliveryOrderInFlight(); // results later used from cache.

  useShakeToSummonScanToPay();

  useLayoutEffect(() => {
    navigation.setOptions({ headerShown: !isMobile });
  }, [navigation, isMobile]);

  const handlePressScanToPay = useCallback(() => {
    navigation.navigate('Modal', { screen: 'ScanToPay' });
  }, [navigation]);

  const handlePressHeroCTA = useHomeHeroCTA(loadedContent.heroCTA?.action);

  if (data.isLoading) return <LoadingAnimation />;

  return (
    <HomeScreenContent
      loadedContent={loadedContent}
      onPressHeroCTA={handlePressHeroCTA}
      onPressScanToPay={handlePressScanToPay}
      {...data}
    />
  );
};
